import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Trash2, Mail, CheckCheck } from "lucide-react";
import { api } from "../../../lib/auth";

export default function StoreMessages() {
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/t/store/messages").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (m) => {
    await api.patch(`/t/store/messages/${m.id}`, null, { params: { read: !m.read } });
    load();
    if (selected?.id === m.id) setSelected({ ...m, read: !m.read });
  };
  const remove = async (m) => {
    if (!window.confirm("Delete message?")) return;
    await api.delete(`/t/store/messages/${m.id}`);
    toast.success("Deleted");
    load();
    setSelected(null);
  };

  return (
    <div data-testid="messages-page" className="p-6 lg:p-8">
      <div className="mb-6">
        <h1 className="font-display font-extrabold text-3xl text-black tracking-tight">Messages</h1>
        <div className="text-sm text-black/55 mt-1">Store · Messages · {rows.length} total</div>
      </div>

      <div className="grid lg:grid-cols-2 gap-5">
        <div className="bg-white rounded-2xl border border-black/5 overflow-hidden h-fit">
          <div className="p-3 border-b border-black/5 text-xs font-bold uppercase tracking-wider text-black/55">Inbox</div>
          <div className="divide-y divide-black/5 max-h-[70vh] overflow-y-auto">
            {rows.map((m) => (
              <button key={m.id} onClick={() => setSelected(m)} data-testid={`msg-${m.id}`}
                className={`w-full text-left p-4 hover:bg-[#FAFBFD] transition-colors ${selected?.id === m.id ? "bg-[#E8F5E9]/40" : ""}`}>
                <div className="flex items-center justify-between">
                  <div className="font-semibold text-sm text-black truncate flex items-center gap-2">
                    {!m.read && <span className="w-2 h-2 rounded-full bg-[#1FA868]" />}
                    {m.name || "Anonymous"}
                  </div>
                  <div className="text-[11px] text-black/45">{(m.created_at || "").slice(0, 10)}</div>
                </div>
                <div className="text-xs text-black/55 truncate mt-0.5">{m.subject || m.message?.slice(0, 60)}</div>
              </button>
            ))}
            {rows.length === 0 && <div className="p-10 text-center text-black/45 text-sm">No messages.</div>}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-black/5 p-6 h-fit">
          {selected ? (
            <>
              <div className="flex items-center justify-between mb-4">
                <div>
                  <div className="font-bold text-lg text-black">{selected.subject || "(no subject)"}</div>
                  <div className="text-xs text-black/55 flex items-center gap-1.5 mt-1"><Mail size={11} /> {selected.email}</div>
                </div>
                <div className="flex gap-1.5">
                  <button onClick={() => markRead(selected)} data-testid="msg-toggle-read"
                    className="p-2 rounded-md bg-[#E8F5E9] text-[#1FA868] hover:bg-[#D1F0DA]"><CheckCheck size={14} /></button>
                  <button onClick={() => remove(selected)} data-testid="msg-delete"
                    className="p-2 rounded-md bg-rose-50 text-rose-600 hover:bg-rose-100"><Trash2 size={14} /></button>
                </div>
              </div>
              <div className="text-sm text-black/75 whitespace-pre-wrap p-4 rounded-xl bg-[#FAFBFD] border border-black/5">
                {selected.message || "(empty)"}
              </div>
              <div className="text-[11px] text-black/45 mt-3">From: {selected.name} · {selected.created_at}</div>
            </>
          ) : (
            <div className="text-center text-black/45 py-20">
              <MessageCircle size={36} className="mx-auto mb-3 opacity-40" />
              Select a message to view
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
